import { render } from "./table.vue?vue&type=template&id=6dcc8bde&scoped=true&ts=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"

import "./table.vue?vue&type=style&index=0&id=6dcc8bde&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcc8bde"]])

export default __exports__